import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";
// import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

// const API_URL = process.env.REACT_APP_BASE_URL;

export const fetchGsts = createAsyncThunk(
  "gst/fetchGsts",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search.trim());
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      // params.append("filters", JSON.stringify(filters));
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            // if (typeof filterValue === "object" && filterValue !== null) {
            //   // Handle cases like { from_date: ..., to_date: ... }
            //   Object.entries(filterValue).forEach(([key, value]) => {
            //     if (value !== undefined && value !== null && value !== "") {
            //       params.append(key, String(value));
            //     }
            //     // if (
            //     //   (filterValue.from_date || filterValue.to_date) &&
            //     //   (filterField === "created_at" || filterField === "updated_at")
            //     // ) {
            //     //   if (filterField === "created_at") {
            //     //     filterField = "created";
            //     //   } else {
            //     //     filterField = "updated";
            //     //   }
            //     //   params.append("filter_by", filterField);
            //     // }
            //   });
            // } else {
            //   // Handle primitive values (string, number)
            //   params.append(filterField, filterValue);
            // }
          }
        },
      );
    }

    const filterPayload = FilterBuilder(filters ?? []);

    const body = {
      filters: filterPayload,
    };
    const response: any = await Axios.post(
      `${API_ENDPOINT.MASTERS.GST.LIST}?${params.toString()}`,
      body,
    );

    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  },
);

export const fetchGstById = createAsyncThunk(
  "gst/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        API_ENDPOINT.MASTERS.GST.DETAIL(id),
      );

      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GST by ID");
    }
  },
);

export const fetchGstByDropDown = createAsyncThunk(
  "Gst/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(API_ENDPOINT.MASTERS.GST.DROPDOWN);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Gst list");
    }
  },
);

export const updateGst = createAsyncThunk(
  "gst/updateGst",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        API_ENDPOINT.MASTERS.GST.UPDATE(data.id),
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GST");
    }
  },
);

export const updateStatusInGst = createAsyncThunk(
  "gst/updateStatusInGst",
  async (data: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: data.is_active };
      const response: any = await Axios.patch(
        API_ENDPOINT.MASTERS.GST.STATUS_UPDATE(data.id),
        payload,
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in GST",
      );
    }
  },
);

export const addGst = createAsyncThunk(
  "gst/addGst",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        API_ENDPOINT.MASTERS.GST.CREATE,
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add GST");
    }
  },
);

export const deleteGst = createAsyncThunk(
  "gst/delete",
  async (id: any, { rejectWithValue }) => {
    try {
      await Axios.delete(API_ENDPOINT.MASTERS.GST.DELETE(id));
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

// export const exportGstCSV = async () => {
//   const response = await Axios.get("/gst/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "Gst.csv",
//   };
// };

export const exportGstCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  // params.append("export", "csv");

  if (search) params.append("search", search);

  // if (filters && filters.length > 0) {
  //   filters.forEach(
  //     ({
  //       filterField,
  //       filterValue,
  //     }: {
  //       filterField: string;
  //       filterValue: any;
  //     }) => {
  //       if (filterField && filterValue !== undefined && filterValue !== null) {
  //         if (typeof filterValue === "object" && filterValue !== null) {
  //           Object.entries(filterValue).forEach(([key, value]) => {
  //             if (value !== undefined && value !== null && value !== "") {
  //               params.append(key, String(value));
  //             }
  //             if (
  //               (filterValue.from_date || filterValue.to_date) &&
  //               (filterField === "created_at" || filterField === "updated_at")
  //             ) {
  //               if (filterField === "created_at") {
  //                 filterField = "created";
  //               } else {
  //                 filterField = "updated";
  //               }
  //               params.append("filter_by", filterField);
  //             }
  //           });
  //         } else {
  //           params.append(filterField, filterValue);
  //         }
  //       }
  //     }
  //   );
  // }
  const filterPayload = FilterBuilder(filters ?? []);
  const body = {
    filters: filterPayload,
  };
  const response = await Axios.post(
    `${API_ENDPOINT.MASTERS.GST.EXPORT}?${params.toString()}`,
    body,
    {
      responseType: "blob",
    },
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "gst"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
